const scrollToTop = () => {
    if (typeof document.scrollTo === 'function') {
        document.documentElement.scrollTo(0, 0);
    } else {
        document.documentElement.scrollTop = 0;
    }
};

export default scrollToTop;
